/* Jeweler words explained in place (snippets/gl-gloss.liquid), 12 Oct 2026.
 * Reads the word list from #gl-gloss-data and, inside every [data-gloss] block,
 * wraps the FIRST use on the page of each word in the tap-to-explain button
 * that assets/gl-term.js already opens and closes. Words inside links, buttons,
 * headings, the questions list or an existing term are skipped. A line that
 * failed to load (Shopify's "translation missing") is never shown.
 */
(function () {
  'use strict';
  var data = document.getElementById('gl-gloss-data');
  var roots = document.querySelectorAll('[data-gloss]');
  if (!data || !roots.length) return;
  var list;
  try { list = JSON.parse(data.textContent); } catch (e) { return; }
  // Commas on both ends so a tag name matches whole: a bare indexOf found P
  // inside SCRIPT and skipped every paragraph.
  var SKIP = ',A,BUTTON,H1,H2,H3,H4,H5,H6,SUMMARY,SCRIPT,STYLE,FIGCAPTION,LABEL,';
  var terms = [];
  list.forEach(function (t) {
    if (!t[1] || /ranslation missing/.test(t[1])) return;
    // "Whole word" without a lookbehind, which throws on Safari before 16.4 and left the glossary silently
    // off there (audit, 15 Oct 2026): the character before the word is matched as group 1 and taken off
    // again in find(). The lookahead after it is fine everywhere.
    try { terms.push({ re: new RegExp('(^|[^\\p{L}\\p{N}])(?:' + t[0] + ')(?![\\p{L}\\p{N}])', 'iu'), line: t[1] }); } catch (e) {}
  });
  var n = 0;

  function skipped(node, root) {
    for (var el = node.parentNode; el && el !== root; el = el.parentNode) {
      if (SKIP.indexOf(',' + el.nodeName + ',') > -1 || (el.classList && (el.classList.contains('gl-term') || el.classList.contains('gl-toc') || el.classList.contains('gl-note')))) return true;
    }
    return false;
  }
  function wrap(textNode, m, line) {
    var after = textNode.splitText(m.index);
    after.splitText(m[0].length);
    var id = 'gl-gloss-' + (++n);
    var span = document.createElement('span');
    span.className = 'gl-term';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gl-term__b';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-describedby', id);
    b.textContent = m[0];
    var p = document.createElement('span');
    p.className = 'gl-term__p';
    p.id = id;
    p.setAttribute('role', 'tooltip');
    p.textContent = line;
    span.appendChild(b);
    span.appendChild(p);
    after.parentNode.replaceChild(span, after);
  }

  terms.forEach(function (t) {
    for (var r = 0; r < roots.length; r++) {
      var walker = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (skipped(node, roots[r])) continue;
        var raw = t.re.exec(node.nodeValue);
        if (raw) {
          var lead = raw[1].length;
          var m = { index: raw.index + lead, 0: raw[0].slice(lead) };
          wrap(node, m, t.line);
          return;
        }
      }
    }
  });
})();
